module.exports = __webpack_public_path__ + "img/1583932246.eeb9d76e.jpg";